// extracted by mini-css-extract-plugin
export var fullWidth = "PlainLink-module--fullWidth--0eb40";
export var iconCenter = "PlainLink-module--iconCenter--203a5";
export var iconTop = "PlainLink-module--iconTop--1ae85";
export var noPadding = "PlainLink-module--noPadding--fd40e";
export var overContainer = "PlainLink-module--overContainer--aac79";
export var root = "PlainLink-module--root--f71c1";
export var textCenter = "PlainLink-module--textCenter--4cfd2";
export var textLeft = "PlainLink-module--textLeft--512c3";
export var textRight = "PlainLink-module--textRight--1d8e9";